import BookFavoriteList from "./book-favorite-list.page";

export default BookFavoriteList;
